export const checkPermissionsMixin = {
  computed: {
    /**
     * Checks if the current user is the SuperAdmin.
     * @returns {boolean}
     */
    isSuperAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
    /**
     * Checks if the current user is the Admin.
     * @returns {boolean}
     */
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    
    isManager() {
      return this.$store.getters.isManager;
    }
  },

  methods: {
    /**
     * Gets the permission name associated with a given layer
     * @param {String} layer - layer name
     * @returns {String}
     */
    getPermissionNameByLayer(layer) {
      return this.$store.getters.getLayerPermissionName(layer);
    },
    //only allow alphanumeric values and numbers
    checkAlphanumeric(e){
      const regex = /[^A-Za-z0-9]/g;
      //if input is different from alphanumeric, validates to true
      if(regex.test(e.key)){
        e.preventDefault();
      }
    },
    //only allow integers
    checkInteger(e) {
      const regex = /[^0-9]/g;
      //if input is different from a number, validates to true
      if(regex.test(e.key)){
        e.preventDefault();
      }
    },
    checkLimit(string, limit){
      return string.length > limit;
    },
    // /**
    //  * Checks if the current user has a given permission.
    //  * @param {String} permissionName - First part of or whole permission name
    //  * @param {String | undefined} action - second part of permission name
    //  * @param {String} role - role to which the permission is associated
    //  * @returns {Boolean}
    //  */
    // userHasPermission(permissionName, role, action = undefined) {
    //   if (this.isSuperAdmin) {
    //     return true;
    //   } else {
    //     let permission = permissionName;
    //     if (action !== undefined) {
    //       permission = permissionName + "_" + action;
    //     }
    //     return (
    //       this.$store.getters.userPermissionsByRole(role) &&
    //       this.$store.getters.hasPermissionInRole(permission, role)
    //     );
    //   }
    // },

    /**
     * Checks if the current user has a given permission.
     * @param {String} permissionName - First part of or whole permission name
     * @returns {Boolean}
     */
    userHasPermission(permissionName) {
      if (this.isSuperAdmin) {
        return true;
      } else {
        return this.$store.getters.userHasPermission(permissionName);
      }
    },

    /**
     * Checks if the current user has a given management permission.
     * @param {String} permissionName - First part of or whole permission name
     * @param {String | undefined} action - second part of permission name
     * @returns {Boolean}
     */
    userHasManagementPermission(permissionName, action = undefined) {
      return this.userHasPermission(permissionName, "management", action);
    },

    /**
     * Checks if the current user has a given Fibercloud/home permission.
     * @param {String} permissionName - First part of or whole permission name
     * @param {String | undefined} action - second part of permission name
     * @returns {Boolean}
     */
    userHasFibercloudPermission(permissionName, action = undefined) {
      return this.userHasPermission(permissionName, "fibercloud_web", action);
    },

    /**
     * Checks if the current user has a given Fibercloud/home permission.
     * @param {String} permissionName - First part of or whole permission name
     * @param {String | undefined} action - second part of permission name
     * @returns {Boolean}
     */
    userHasModulePermission(permissionName, action = undefined) {
      return this.userHasPermission(permissionName, "modules", action);
    },

    getMissingPermissionsList(neededPermissions) {
      let missingPermissionsList = [];
      neededPermissions.forEach(item => {
        if (!this.userHasManagementPermission(item)) {
          missingPermissionsList.push(item);
        }
      });
      return missingPermissionsList;
    },

    hasNeededPermissionsTo(missingPermissionsList) {
      return missingPermissionsList.length === 0;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/checkPermissionsMixin.js